export default class ConfirmBeforeLeave {
    constructor(formSelector) {
        this.formIsDirty = false;
        this.form = null;
        this.formSelector = formSelector;
    }
    start() {
        this.form = document.querySelector(this.formSelector);
        if (!this.form)
            return;
        // Mark form as dirty when user changes any input
        this.form.addEventListener('input', () => {
            this.formIsDirty = true;
        });
        // Also track change events for selects/checkboxes/radios
        this.form.addEventListener('change', () => {
            this.formIsDirty = true;
        });
        // Clear dirty flag on successful submit
        this.form.addEventListener('submit', () => {
            this.formIsDirty = false;
        });
        // Show warning when leaving page
        window.addEventListener('beforeunload', (e) => {
            if (this.formIsDirty) {
                e.preventDefault();
                // Modern browsers ignore custom messages, but this is still required
                e.returnValue = '';
                return 'Wenn Sie diese Seite tatsächlich verlassen, gehen alle Eingaben verloren!';
            }
        });
    }
}
